<template lang="pug">
  .pRow
    .pRow__chatBody.d-inline-block.position-relative
      .chatBody__outSideBox
        .row.flex-row-reverse.no-gutters.align-items-start.flex-nowrap
          .pRow__profileImg.ml-3.d-none(
            v-if="this.profile_picture",
            @click="showLightBox(profile_picture)"
          )
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
              :profileUrl="this.profile_picture",
              :style="{ 'width': '50px', 'height': '50px' }"
            )
          .d-flex.align-items-end.flex-nowrap.flex-row-reverse.no-gutters
            .pRow__content.pRow__imgBox.position-relative.d-flex.align-items-center
              .imgBox__insideImgBox
                b-img.rounded.cursor-pointer(
                  v-lazy="this.messageData.url || this.messageData.image",
                  fluid,
                  alt="Personnel Send Img",
                  :onerror="defaultPreviewImg",
                  @click="showLightBox(messageData.url ? messageData.url : messageData.image ? messageData.image : null)"
                )
            .pRow__timeBox
              span.text-right(
                v-if="this.messageData.is_read"
              ) 已讀
              span.cursor-default.text-right {{ filterToday(this.messageData.time) }}
</template>

<script>
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import defaultPreviewImgUrl from '@/assets/images/default/defaultImg404.png';

export default {
  name: 'P-Img',
  components: {
    ProfilePhotoSticker
  },
  props: {
    messageData: {
      type: Object,
      required: true
    },
    profile_picture: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      defaultPreviewImg: `this.src="${defaultPreviewImgUrl}"`
    };
  },
  methods: {
    // 通知父組件顯示幻燈片
    showLightBox(imageUrl) {
      this.$emit('showLightBox', imageUrl);
    }
  }
};
</script>

<style>

</style>
